module.exports = __webpack_public_path__ + "img/icon-minimize.a979d68c.svg";